import { useEffect, useState } from "react";
import { Flex, VStack, HStack, Heading, Box, Skeleton, Text, useColorModeValue } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { getCompanyById } from "@/services/companies-service";
import { formatDate, ICompany, useAuth } from "@bemap/utils";
import { useTranslation } from "react-i18next";

const ViewCompanyPage = () => {
  const { companyId } = useParams();
  const { user } = useAuth();
  const { t } = useTranslation();

  const initialCompany: ICompany = {
    id: 0,
    name: '',
    number_id: '',
    team_id: parseInt(`${user?.currentTeamId}`),
  };

  const [company, setCompany] = useState<ICompany>(initialCompany);
  const [isLoading, setIsLoading] = useState(false);

  const titleColor = useColorModeValue('gray.900', 'white');
  const textColor = useColorModeValue('gray.600', 'gray.50');

  async function loadCompany() {
    setIsLoading(true);
    try {
      const response = await getCompanyById(parseInt(companyId || '0'));
      setCompany(response.message);
      setIsLoading(false);
    } catch (error) {
      setCompany(initialCompany);
      setIsLoading(false);
    }
  }

  useEffect(() => {
    loadCompany();
  }, [companyId]);

  const InfoRow = ({ title, text, isLoading = false }: { title: string; text: string; isLoading?: boolean }) => (
    <Box flexGrow={"1"}>
      <Text fontSize="1.1rem" fontWeight={'bold'} color={titleColor}>{title}</Text>
      <Skeleton minHeight="20px" isLoaded={!isLoading}>
        <Text color={textColor}>{text || ""}</Text>
      </Skeleton>
    </Box>
  );

  return (
    <>
      <VStack gap="20px">
        <HStack justify="space-between" px={4} pt={4} w="100%">
          <VStack align="start">
            <Heading>{company.name || t('analyst.companies')}</Heading>
          </VStack>
        </HStack>
        <Box
          flexDirection='column'
          w='100%'
          px='0px'
          background={useColorModeValue('white', 'rgba(255,255,255,0.05)')}
          borderRadius='0.375rem'
          p="25px"
        >
          <Text
            mt='0px'
            color={titleColor}
            fontSize='22px'
            fontWeight='700'
            lineHeight='100%'
            mb="20px"
          >
            {t('analyst.companies_info')}
          </Text>
          <Flex direction="row" gap={4}>
            <InfoRow
              title={t('analyst.companies_table_name')}
              text={company.name || ''}
              isLoading={isLoading}
            />
            <InfoRow
              title={t('analyst.companies_table_cnpj')}
              text={company.number_id || ''}
              isLoading={isLoading}
            />
            <InfoRow
              title={t('analyst.companies_table_created')}
              text={formatDate(company.created_at || '')}
              isLoading={isLoading}
            />
          </Flex>
        </Box>
      </VStack>
    </>
  );
};

export default ViewCompanyPage; 